import React, { useContext, useEffect, useMemo, useState } from "react";
import CheckListFBYInput from "../../../../../blocks/FormItems/CheckListFBYInput";
import { Typography } from "antd";
import { presentIllnessOptions } from "../../../Options/historyOptions";
const { Text } = Typography;

const PresentIllness = ({ context, form }) => {
  const { formData } = useContext(context);

  // Handle both nested (edit mode) and flat (voice mode) structure
  const historyData = formData?.history || formData;

  const initialValues = useMemo(() => historyData, [historyData]);
  const [checkboxes, setCheckboxes] = useState([]);

  useEffect(() => {
    const initialCheckboxes = presentIllnessOptions.reduce((acc, checkbox) => {
      // Check in both nested and flat structure
      acc[checkbox.value] = initialValues?.[checkbox.value] || false;
      return acc;
    }, {});
    setCheckboxes(initialCheckboxes);
  }, [initialValues]);

  return (
    <>
      <Text>Present Illness</Text>
      <CheckListFBYInput
        options={presentIllnessOptions}
        checkboxes={checkboxes}
        setCheckboxes={setCheckboxes}
        others_key={"illness_others"}
        form={form}
        field_key={"present_illness_others"}
      />
    </>
  );
};

export default PresentIllness;
